import React from "react";
import CartItem from "./CartItem";
import Headline from "~/assets/js/components/Typography/Headline";
import i18n from "~/assets/js/Helpers/i18n";
import PropTypes from "prop-types";
import { applyNoReusableBowlsFilter } from "~/assets/js/Helpers/reusable-bowls-utils";
import CartEmptyDisclamer from "../CartEmptyDisclamer";
import useGroupOrder from "../../global/useGroupOrder";
import i18next from "~/assets/js/Helpers/i18n";

const CartItems = ({ cartItems }) => {
    const { isOwner, isGroupOrder } = useGroupOrder();
    let items = cartItems?.filter(applyNoReusableBowlsFilter) || [];

    // Only show owner items
    if (isOwner) {
        const cookie = window.cookie.get();
        const owner_uid = cookie.participant.uid;
        items = items.filter((item) => item.owner_uid === owner_uid);
    }

    if (items.length <= 0) {
        return (
            <CartEmptyDisclamer
                labels={{
                    disclamer: isGroupOrder
                        ? i18next.t("memberGroupOrder.emptyDisclaimer")
                        : i18next.t("cart.emptyDisclamer"),
                }}
            />
        );
    }

    return (
        <>
            <Headline size={6} resizable>
                {i18n.t("cart.product")}
            </Headline>
            {items.map((cartItem, index) => (
                <CartItem
                    key={cartItem.product_id}
                    cartItem={cartItem}
                    inCartPosition={index}
                    items={cartItems}
                />
            ))}
        </>
    );
};

CartItems.propTypes = {
    cartItems: PropTypes.array.isRequired,
};

export default CartItems;
